import {
  Container,
  Typography,
  TextField,
  Button,
} from '@material-ui/core';

export default function QuestionForm() {
    return (
    <Container component="main" maxWidth="md">
      <Typography variant="h5">Ask a Question</Typography>
      <form action="/chat" method="get">
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          name="sayTitle"
          label="Title"
          id="sayTitle"
        />
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          name="question"
          label="What is your question"
          multiline
          id="question"
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          style={{ margin: '24px 0' }}
        >
          Ask
        </Button>
      </form>
    <Typography variant="h5">Say</Typography>
    <form action="/chat" method="get">
      <TextField
        variant="outlined"
        margin="normal"
        fullWidth
        name="sayTitle"
        label="Title"
        id="sayTitle"
      />

      <TextField
        variant="outlined"
        margin="normal"
        fullWidth
        name="say"
        label="What do you want to say"
        multiline
        id="question"
      />

      <TextField
        variant="outlined"
        margin="normal"
        fullWidth
        name="topicToDiscuss"
        label="Topic to discuss"
        id="topicToDiscuss"
      />

      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        style={{ margin: '24px 0' }}
      >
        Say
      </Button>
    </form>

    <Typography variant="h5">Book</Typography>
    <form action="/chat" method="get">
      <TextField
        variant="outlined"
        margin="normal"
        fullWidth
        name="bookId"
        label="Book ID"
        id="bookId"
      />

      <TextField
        variant="outlined"
        margin="normal"
        fullWidth
        name="topicToDiscuss"
        label="Topic to discuss"
        id="topicToDiscuss"
      />

      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        style={{ margin: '24px 0' }}
      >
        Summarize Book
      </Button>
    </form>
    </Container>
  );
}
